










import { Component, Prop, Vue } from 'vue-property-decorator'
import { Penalty } from 'match-central-shared/src/types/penalties'

@Component
export default class TeamView extends Vue {
  @Prop() readonly penalties!: Penalty[]
  @Prop() readonly teamShort!: 'h' | 'v'
}
